import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  TextField,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { HiOutlineUser } from "react-icons/hi";
import { styled } from '@mui/system';

const Title = styled('h1')({
  textAlign: 'center',
  color: '#0d47a1',
  marginBottom: '30px',
  fontSize: '2.5rem',
  fontFamily: 'Roboto, sans-serif',
  borderBottom: "2px solid rgb(13, 71, 161)",
});

const HeaderToolbar = ({
  selectedOption,
  handleOptionChange,
  startDate,
  handleDateChange,
  selectedUser,
  handleUserChange,
  activeUsers,
  adjustDates,
  handleExportCSV,
}) => {
  return (
    <div>
      {/* Title */}
      <Title>
      <h1 class="sticky top-0 mb-4 text-3xl md:text-4xl font-extrabold text-gray-900 dark:text-black"><span class="text-transparent font-extrabold bg-clip-text bg-gradient-to-r to-emerald-600 from-sky-400">User</span> Analysis</h1>
      </Title>
      {/* Toolbar Container */}
      <div className="sticky top-0 bg-white z-10 flex flex-wrap md:flex-nowrap items-center gap-4 p-4 shadow-md w-full">
        {/* Date Range Dropdown */}
        <FormControl className="w-full md:w-[150px]">
          <InputLabel className="bg-white !px-[5px]" id="date-range-label">Select Range</InputLabel>
          <Select
            labelId="date-range-label"
            id="date-range"
            value={selectedOption}
            onChange={handleOptionChange}
          >
            <MenuItem value="week">Week</MenuItem>
            <MenuItem value="month">Month</MenuItem>
          </Select>
        </FormControl>

        {/* Date Picker */}
        <div className="w-full md:flex-1">
          <DatePicker
            views={selectedOption === "month" ? ["year", "month"] : undefined}
            label={selectedOption === "month" ? "Select Month" : "Select Date"}
            value={startDate}
            onChange={handleDateChange}
            renderInput={(params) => <TextField {...params} fullWidth />}
          />
        </div>

        {/* User Selection Dropdown */}
        <FormControl className="w-full md:w-[350px]">
          <InputLabel className="bg-white !px-[5px]" id="user-select-label">Select User</InputLabel>
          <Select
            labelId="user-select-label"
            className="capitalize"
            value={selectedUser || ""}
            onChange={handleUserChange}
          >
            {activeUsers?.map((user) => (
              <MenuItem key={user._id} value={user._id}>
                <div className="flex items-center space-x-2">
                  <HiOutlineUser className="text-gray-600 text-lg" />
                  <span>{`${user?.fname} ${user?.lname}`}</span>
                </div>
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Navigation Buttons */}
        <div className="flex space-x-2">
          <Button variant="outlined" onClick={() => adjustDates("prev")}>
            Previous
          </Button>
          <Button variant="outlined" onClick={() => adjustDates("next")}>
            Next
          </Button>
        </div>

        {/* Export CSV Button */}
        <Button
          variant="contained"
          color="secondary"
          onClick={handleExportCSV}
          disabled={!selectedUser}
        >
          Export CSV
        </Button>
      </div>
    </div>
  );
};

export default HeaderToolbar;
